import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';

import { isDevelopment, transform404Error } from '@/utils/application';

import Button from '../components/elements/button';

import classes from '../scss/screens/error.module.scss';

export default function Error() {
    const error = useRouteError() as Response & Error;
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div id='error-page' className={classes.error_page}>
            <span className={classes.header}>{t('error:oops')}</span>
            <p className={classes.p}>{t('error:subtitle')}</p>
            {isDevelopment() && (
                <i>{transform404Error(error.statusText || error.message)}</i>
            )}
            <p className={classes.p1}>{t('error:not_found')}</p>
            <Button onclick={() => navigate('/')} type='primary' size='medium'>
                {t('error:go_back')}
            </Button>
        </div>
    );
}
